import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AboutUsView extends Component {
  static propTypes = {
    text: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="container">
          <div className="container-title">{this.props.translations['menu.aboutUs']}</div>
          <div
            className="u-mt-3"
            style={{
              textAlign: 'justify',
              gridColumn: '1/13',
            }}
          >
            {this.props.translations['menu.aboutUsDesc']}
          </div>
        </div>
      </div>
    );
  }
}

export default AboutUsView;
